import { render, staticRenderFns } from "./SliderNew.vue?vue&type=template&id=604a611a&scoped=true&"
import script from "./SliderNew.vue?vue&type=script&lang=js&"
export * from "./SliderNew.vue?vue&type=script&lang=js&"
import style0 from "./SliderNew.vue?vue&type=style&index=0&id=604a611a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a611a",
  null
  
)

export default component.exports